module.exports = __webpack_public_path__ + "img/gb74.prt.6e33b514.jpg";